module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/hero-mobile@2x.15234e9.jpg";